import { useNavigate } from 'react-router';

import { Button } from '@/components/ui/button';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className={'base-direction-row flex-col items-center justify-center gap-6'}>
      <div className={'space-y-2'}>
        <h1 className={'text-center text-4xl leading-snug font-semibold whitespace-nowrap md:text-start md:text-6xl'}>
          Nie znaleziono <br /> takiej strony
        </h1>
        <p className={'text-text-tertiary text-center text-xs md:text-start md:text-sm'}>Niestety, strona której szukasz nie istnieje.</p>
      </div>
      <div className={'flex flex-col gap-3 md:flex-row'}>
        <Button variant={'secondary'} onClick={() => void navigate('/')}>
          Wróć do strony główna
        </Button>
        <Button variant={'tertiary'} onClick={() => void navigate(-1)}>
          Wróć
        </Button>
      </div>
    </div>
  );
}
